<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $t("smstemplate") }}
      </div>
      <div>
        <router-link class="btn-blue" to="sms-template"
          >{{ $t("smstemplate") }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="input-material">
            <input
              v-model="sms_temp_name"
              v-validate="'required'"
              placeholder="."
              type="text"
              name="smstemplatename"
              id="smstemplatename"
            />
            <label>{{ $t("smstemplate") }} {{ $t("name") }}</label>
          </div>
          <p
            v-if="submitted && errors.has('smstemplatename')"
            class="error_message"
          >
            <span>{{ errors.first("smstemplatename") }}</span>
          </p>
        </div>

        <div class="col-lg-12 col-xl-12 mb-4">
          <div class="d-flex">
            <div class="input-material-textarea">
              <textarea
                v-model="content"
                rows="5"
                v-validate="'required'"
                type="text"
                name="smstext"
                id="smstext"
                class="rounded-10"
              ></textarea>
              <label>Text</label>
            </div>
          </div>
          <p v-if="submitted && errors.has('smstext')" class="error_message">
            <span>{{ errors.first("smstext") }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  v-model="sms_temp_is_active"
                  switch
                  name="check-button"
                  class="j-checkbox"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit()"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button @click.prevent.stop="onResetForm" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="sms-template"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      submitted: false,
      content: "",
      sms_temp_name: "",
      sms_temp_is_active: true,
      keys: [],
    };
  },
  beforeMount() {},
  methods: {
    onResetForm: function () {
      this.submitted = false;
      this.content = "";
      this.sms_temp_name = "";
      this.sms_temp_is_active = true;
    },
    OnFinalSubmit: function () {
      this.submitted = true;

      this.$validator.validate().then((valid) => {
        if (valid) {
          this.btenable = true;

          let payload = {
            sms_name: this.sms_temp_name,
            content: this.content,
            sms_is_active: this.sms_temp_is_active,
          };

          MasterService.AddSMSTemplate(payload)
            .then((response) => {
              this.btenable = false;

              const { data } = response;

              if (data && data.status) {
                this.submitted = false;

                this.$router.push({
                  path: "/master/sms-template",
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/SMSTemplateComponents/addsmstemplate.vue